import { EdicaoRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/pages/cadastramento/EdicaoRelatorioAM";
import { ListaRelatoriosAM } from "@/contexts/fiscalizacao/relatorioAM/pages/cadastramento/ListaRelatoriosAM";
import { NovoRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/pages/cadastramento/NovoRelatorioAM";
import { VisualizacaoRAM } from "@/contexts/fiscalizacao/relatorioAM/pages/cadastramento/VisualizacaoRAM";
import { NovoParecerRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/pages/planoAcao/NovoParecerRelatorioAM";
import { NovoPlanoAcaoRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/pages/planoAcao/NovoPlanoAcaoRelatorioAM";
import { PlanoAcaoRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/pages/planoAcao/PlanoAcaoRelatorioAM";
import { RemocaoParecerRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/pages/planoAcao/RemocaoParecerRelatorioAM";
import { VisualizacaoPlanoAcaoRAM } from "@/contexts/fiscalizacao/relatorioAM/pages/planoAcao/VisualizacaoPlanoAcaoRAM";
import { Route } from "react-router";

// As rotas são renderizadas dentro do layout autenticado em app/routes.tsx.
// Retorna um Fragment (e não um componente) porque <Routes> só aceita
// <Route> ou Fragment como filhos diretos.
export function relatorioAMRoutes() {
  return (
    <>
      <Route path="/RAM/lista" element={<ListaRelatoriosAM />} />
      <Route path="/RAM/novo" element={<NovoRelatorioAM />} />
      <Route
        path="/RAM/lista/editar/:offlineId"
        element={<EdicaoRelatorioAM />}
      />
      <Route path="/RAM/visualizar/:id" element={<VisualizacaoRAM />} />
      <Route path="/RAM/plano-acao" element={<PlanoAcaoRelatorioAM />} />
      <Route
        path="/RAM/plano-acao/novo/:relatorioId"
        element={<NovoPlanoAcaoRelatorioAM />}
      />
      <Route
        path="/RAM/plano-acao/visualizar/:id"
        element={<VisualizacaoPlanoAcaoRAM />}
      />
      <Route
        path="/RAM/plano-acao/parecer/:relatorioId"
        element={<NovoParecerRelatorioAM />}
      />
      <Route
        path="/RAM/plano-acao/parecer/remover/:relatorioId"
        element={<RemocaoParecerRelatorioAM />}
      />
    </>
  );
}
